import { render, staticRenderFns } from "./CompanionDetailView.vue?vue&type=template&id=308706b7&scoped=true"
import script from "./CompanionDetailView.vue?vue&type=script&lang=js"
export * from "./CompanionDetailView.vue?vue&type=script&lang=js"
import style0 from "./CompanionDetailView.vue?vue&type=style&index=0&id=308706b7&prod&scoped=true&lang=scss"
import style1 from "./CompanionDetailView.vue?vue&type=style&index=1&id=308706b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308706b7",
  null
  
)

export default component.exports